import { PageList } from '../../constants/pageList';
import { isExpressCheckout } from '../common/Helpers';

const stepMap = {
  PlanSelection: PageList.PROGRESSIVE_PLAN,
  Accessories: PageList.ADDONS,
  InstallType: PageList.SETUP,
  ExpressCheckOut: PageList.EXPRESS_CHECKOUT,
  ShoppingCart: PageList.CART,
  ExpressCart : PageList.CART,
};

export const getResumeCartPage = (nextStep, isResumeCart, isStreamline) => {
  const isExpressCheckoutFlow = isExpressCheckout();
  
  const cartPage = isExpressCheckoutFlow ? PageList.EXPRESS_CHECKOUT : PageList.CART;
  const defaultPage = isStreamline ? PageList.STREAMLINE_ORDER : PageList.PROGRESSIVE_PLAN;

  const stepRedirectionMap = {
    ...stepMap,
    ShoppingCart: cartPage,
  };

  return stepRedirectionMap[nextStep] || (isResumeCart ? cartPage : defaultPage);
};
